module.exports = __webpack_public_path__ + "img/qr_chadle.5c0ff6e8.svg";